module.exports = __webpack_public_path__ + "img/kensrin.1f16223e.png";